// extracted by mini-css-extract-plugin
export default {"font-renta":"HomePage_font-renta__09-AS","home":"HomePage_home__zD7i6","alert":"HomePage_alert__MGOcp"};